import classNames from 'classnames';

import * as styles from './InlineLink.css';
import type { LeafMarkProps } from './Text.types';

export function TimestampLinkElement(props: LeafMarkProps) {
  const { mark, children, className } = props;
  const seconds = mark.attrs?.seconds ?? 0;

  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    const audio = document.querySelector('audio');
    if (audio) {
      audio.currentTime = seconds;
      audio.play().catch(() => {
        // Auto-play blocked, user will need to click play
      });
    }
  };

  return (
    <a href={`#t=${seconds}`} onClick={handleClick} className={classNames(className, styles.linkElement)}>
      {children}
    </a>
  );
}
